package com.essntl.features.task.ui.alltasks.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.esIconPainterResource
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun NoTasksComponent() {
    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Image(
            painter = esIconPainterResource(EsIcons.EmptySearch),
            contentDescription = null,
            modifier = Modifier
                .width(200.dp)
                .height(200.dp)
                .align(Alignment.CenterHorizontally),
        )

        Text(
            text = "Nothing was found",
            color = MaterialTheme.esColorScheme.textSecondary,
            style = MaterialTheme.esTypography.p1Medium16,
            textAlign = TextAlign.Center,
            modifier = Modifier
                .align(Alignment.CenterHorizontally)
                .padding(end = 2.spacing),
        )
    }
}